<div class="mx-auto p-2 w-full">
    <div class="w-full m-0 pt-3">
        <div class="w-full flex justify-end text-right p-0 pt-3">
            <div class="flex justify-end gap-2"*ngIf="dataSource.data.length > 0">
                <button class="group relative  flex justify-center py-2 px-4 border border-transparent bg-[#E31C79] text-sm text-white font-normal rounded-md hover:bg-rose-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" (click)="toggleEdit()" >Edit</button>
                <button *ngIf="edit" class="group relative  flex justify-center py-2 px-4 border border-transparent bg-[#E31C79] text-sm text-white font-normal rounded-md  hover:bg-rose-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" (click)="save()" >Save</button>
                <span *ngIf="!edit" (click)="toggleExport()" class="pr-2 pdicon cursor-pointer pl-2">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor"
                        class="bi bi-three-dots-vertical" viewBox="0 0 16 16">
                        <path
                            d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0" />
                    </svg>
                </span>
            </div>
        </div>
        <div class="w-full flex justify-end items-end text-right p-0 pt-3 mt-6">
            <button *ngIf="showExport" class="group absolute w-1/12 flex justify-center py-2 px-4 border border-transparent bg-[#E31C79] text-sm text-white font-normal rounded-md hover:bg-rose-700 focus:outline-none focus:ring-2 focus:ring-offset-2" (click)="exportToPdf()" >Export to
                PDF</button>
            <button *ngIf="dataSource.data.length === 0" class="group relative w-3/12 flex justify-center py-2 px-4 border border-transparent bg-[#E31C79] text-sm text-white font-normal rounded-md hover:bg-rose-700 focus:outline-none focus:ring-2 focus:ring-offset-2" (click)="addData()" >Add Data And Assessment Plan</button>
        </div>



        <div #contentToExport>
            <div *ngIf="dataSource.data.length > 0" class="my-2">
                <table mat-table [dataSource]="dataSource" class="w-full pb-4 mb-4" >
                    <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef class="bg-rose-700"> Assessment Name </th>
                    <tr *ngIf="!edit"><td mat-cell *matCellDef="let element"> {{element.name}} </td></tr>
                    <tr *ngIf="edit"><td mat-cell *matCellDef="let element" class="rounded-l shadow-md"> <textarea 
                        [(ngModel)]="element.name"
                        style="overflow: hidden;"
                        cdkTextareaAutosize
                        cdkAutosizeMinRows="3"
                        [rows]="3"
                        class="w-full p-3 my-1 rounded-l shadow-md border border-gray-300 outline-none focus:border-blue-400 text-black text-sm"
                        type="text"
                        maxlength="65535"
                        placeholder="IXL, STAR, i-Ready, Terra Nova"
                    ></textarea> </td></tr>
                    
                    </ng-container>
                
                    <ng-container matColumnDef="type">
                    <th mat-header-cell *matHeaderCellDef> Assessment Type </th>
                    <tr *ngIf="!edit"><td mat-cell *matCellDef="let element"> {{element.type}} </td></tr>
                    <tr *ngIf="edit"><td mat-cell *matCellDef="let element" class="rounded-l shadow-md"> <textarea 
                        [(ngModel)]="element.type"
                        style="overflow: hidden;"
                        cdkTextareaAutosize
                        cdkAutosizeMinRows="3"
                        [rows]="3"
                        class="w-full p-3 my-1 rounded-l shadow-md border border-gray-300 outline-none focus:border-blue-400 text-black text-sm"
                        type="text"
                        maxlength="65535"
                        placeholder="Formative, Summative, Online"
                    ></textarea> </td></tr>
                    </ng-container>
                
                    <ng-container matColumnDef="assessed">
                    <th mat-header-cell *matHeaderCellDef> Who is Assessed? </th>
                    <tr *ngIf="!edit"><td mat-cell *matCellDef="let element"> {{element.assessed}} </td></tr>
                    <tr *ngIf="edit"><td mat-cell *matCellDef="let element" class="rounded-l shadow-md"> <textarea 
                        [(ngModel)]="element.assessed"
                        style="overflow: hidden;"
                        cdkTextareaAutosize
                        cdkAutosizeMinRows="3"
                        [rows]="3"
                        class="w-full p-3 my-1 rounded-l shadow-md border border-gray-300 outline-none focus:border-blue-400 text-black text-sm"
                        type="text"
                        maxlength="65535"
                        placeholder="All or select grades"
                    ></textarea> </td></tr>
                    </ng-container>
                
                    <ng-container matColumnDef="date">
                    <th mat-header-cell *matHeaderCellDef> When is data collected? </th>
                    <tr *ngIf="!edit"><td mat-cell *matCellDef="let element"> {{element.date}} </td></tr>
                    <tr *ngIf="edit"><td mat-cell *matCellDef="let element" class="rounded-l shadow-md"> <textarea 
                        [(ngModel)]="element.date"
                        style="overflow: hidden;"
                        cdkTextareaAutosize
                        cdkAutosizeMinRows="3"
                        [rows]="3"
                        class="w-full p-3 my-1 rounded-l shadow-md border border-gray-300 outline-none focus:border-blue-400 text-black text-sm"
                        type="text"
                        maxlength="65535"
                        placeholder="MM/DD/YYYY"
                    ></textarea> </td></tr>
                    </ng-container>
                
                    <ng-container matColumnDef="target">
                    <th mat-header-cell *matHeaderCellDef> Learning Target </th>
                    <tr *ngIf="!edit"><td mat-cell *matCellDef="let element"> {{element.target}} </td></tr>
                    <tr *ngIf="edit"><td mat-cell *matCellDef="let element" class="rounded-l shadow-md"> <textarea 
                        [(ngModel)]="element.target"
                        style="overflow: hidden;"
                        cdkTextareaAutosize
                        cdkAutosizeMinRows="3"
                        [rows]="3"
                        class="w-full p-3 my-1 rounded-l shadow-md border border-gray-300 outline-none focus:border-blue-400 text-black text-sm"
                        type="text"
                        maxlength="65535"
                        placeholder="ELA, Math, Science, Social Studies, Religion"
                    ></textarea> </td></tr>
                    </ng-container>
                
                    <ng-container class="w-1/12" matColumnDef="responsibility">
                    <th mat-header-cell *matHeaderCellDef> Who is responsible for collecting and keeping track of data? </th>
                    <tr *ngIf="!edit"><td mat-cell *matCellDef="let element"> {{element.responsibility}} </td></tr>
                    <tr *ngIf="edit"><td mat-cell *matCellDef="let element" class="rounded-l shadow-md"> <textarea 
                        [(ngModel)]="element.responsibility"
                        style="overflow: hidden;"
                        cdkTextareaAutosize
                        cdkAutosizeMinRows="3"
                        [rows]="3"
                        class="w-full p-3 my-1 rounded-l shadow-md border border-gray-300 outline-none focus:border-blue-400 text-black text-sm"
                        type="text"
                        maxlength="65535"
                        placeholder="Name of staff member(s)"
                    ></textarea> </td></tr>
                    </ng-container>
                
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>
                <div class="w-full flex justify-end items-end text-right p-0 pt-3 mt-6">
                    <button *ngIf="edit" class="group relative w-2/12 flex justify-center py-2 px-4 border border-transparent text-sm rounded-md bg-[#E31C79] text-white font-normal hover:bg-rose-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" (click)="addRow()" >Add Row</button>
                </div>
            </div>
        </div>
    </div>
</div>


